<template>
    <section class="py-16 px-4 md:px-8">
        <div class="container mx-auto grid grid-cols-1 sm:grid-cols-3 gap-8">
            <!-- About Us Card -->
            <div
                class="bg-gradient-to-r from-green-700 via-green-800 to-green-900 p-6 rounded-lg shadow-lg flex flex-col justify-between">
                <h2 class="text-2xl font-semibold text-white mb-4">About Us</h2>
                <p class="text-white mb-4">Learn more about our club, its history, and the values we stand for. We're
                    here to build a strong community and offer valuable experiences.</p>
                <router-link to="/about"
                    class="self-center inline-block bg-white text-green-600 px-6 py-2 rounded-lg transition-colors hover:bg-green-600 hover:text-white">
                    Read Here
                </router-link>
            </div>

            <!-- Blood Donor -->
            <div
                class="bg-gradient-to-r from-green-700 via-green-800 to-green-900 p-6 rounded-lg shadow-lg flex flex-col justify-between">
                <h2 class="text-2xl font-semibold text-white mb-4">Blood Donor Platform</h2>
                <p class="text-white mb-4">Join us in saving lives by becoming a blood donor today.</p>
                <router-link to="/blood-donation"
                    class="self-center inline-block bg-white text-green-600 px-6 py-2 rounded-lg transition-colors hover:bg-green-600 hover:text-white">
                    Learn More
                </router-link>
            </div>
            <!-- Apply for Membership Card -->
            <div
                class="bg-gradient-to-r from-green-700 via-green-800 to-green-900 p-6 rounded-lg shadow-lg flex flex-col justify-between">
                <h2 class="text-2xl font-semibold text-white mb-4">Apply for Membership</h2>
                <p class="text-white mb-4">Join our community and be part of something special. Apply now and start
                    enjoying the benefits of being a member.</p>
                <router-link to="/membership"
                    class="self-center inline-block bg-white text-green-600 px-6 py-2 rounded-lg transition-colors hover:bg-green-600 hover:text-white">
                    Apply Here
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "SectionOne",
};
</script>

<style scoped>
.container {
    max-width: 1200px;
}

.card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

button {
    transition: background-color 0.3s;
}

button:hover {
    background-color: #3490dc;
    color: white;
}
</style>
